module.exports = __webpack_public_path__ + "static/media/Location_Book-Page17.63f78856.png";